<template>
  <h1 class="hero-title fade-in-up delay-1">
    <slot>
      <template v-if="highlightText">
        <span class="title-line-1">{{ titleBefore }}</span><span class="title-line-2 highlight-gradient">{{ highlightText }}</span><span class="title-line-3">{{ titleAfterPart1 }}</span><span class="title-line-4">{{ titleAfterPart2 }}</span>
      </template>
      <template v-else>
        {{ title }}
      </template>
    </slot>
  </h1>
</template>

<script>
export default {
  name: 'HeroTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    highlightText: {
      type: String,
      default: ''
    }
  },
  computed: {
    titleBefore() {
      if (!this.highlightText || !this.title) return this.title
      const index = this.title.indexOf(this.highlightText)
      return index > -1 ? this.title.substring(0, index).trim() : this.title
    },
    titleAfter() {
      if (!this.highlightText || !this.title) return ''
      const index = this.title.indexOf(this.highlightText)
      return index > -1 ? this.title.substring(index + this.highlightText.length).trim() : ''
    },
    titleAfterPart1() {
      const after = this.titleAfter.trim()
      if (!after) return ''
      // Divide "sempre a portata di mano" in "sempre a portata" e "di mano"
      const parts = after.split(' ').filter(p => p.length > 0)
      if (parts.length >= 3) {
        // Prende le prime 3 parole (sempre a portata)
        return parts.slice(0, 3).join(' ')
      }
      return after
    },
    titleAfterPart2() {
      const after = this.titleAfter.trim()
      if (!after) return ''
      // Prende le ultime 2 parole (di mano)
      const parts = after.split(' ').filter(p => p.length > 0)
      if (parts.length > 3) {
        return parts.slice(3).join(' ')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-title {
  font-size: 4rem;
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 24px;
  letter-spacing: -0.02em;

  // Su desktop, gli span sono inline con spazi
  .title-line-1::after {
    content: ' ';
  }
  
  .title-line-2::after {
    content: ' ';
  }
  
  .title-line-3::after {
    content: ' ';
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
    display: flex;
    flex-direction: column;
    
    .title-line-1,
    .title-line-3,
    .title-line-4 {
      display: block;
    }
    
    .title-line-2 {
      display: inline-block; // Rimane inline-block così la linea è solo sotto il testo
    }
    
    // Rimuove gli spazi su mobile
    .title-line-1::after,
    .title-line-2::after,
    .title-line-3::after {
      content: '';
    }
  }
  
  .highlight-gradient {
    background: linear-gradient(135deg, #fff 0%, #a5b4fc 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    display: inline-block;

    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      right: 0;
      width: auto;
      height: 6px;
      background: linear-gradient(90deg, #fff, #a5b4fc);
      border-radius: 2px;
      opacity: 0.5;

      @media (max-width: 768px) {
        bottom: -3px;
        height: 5px;
        // Su mobile la linea è già solo sotto il testo perché title-line-2 è inline-block
      }
    }
  }
}
</style>
